import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule, DataTableModule, FileUploadModule, GrowlModule, DialogModule, TooltipModule } from 'primeng/primeng';

import { UserImportComponent } from './user-import/user-import.component';
import { ImportErrorComponent } from './import-error/import-error.component';
import { UploaderModule } from 'app/uploader';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    DataTableModule,
    FileUploadModule,
    GrowlModule,
    DialogModule,
    TooltipModule,
    TranslateModule,
    UploaderModule
  ],
  declarations: [
    UserImportComponent,
    ImportErrorComponent
  ],
  providers: []
})
export class UserImportModule { }



// WEBPACK FOOTER //
// /dist/src/app/import/user-import.module.ts